import { get, post } from "helpers/api_helper/ApiHelpers/apiHelpers"
// import { get, post } from "helpers/api_helper/MerchantApiHelpers/merchantApiHelpers"
import * as url from "helpers/url_helper/url_helper"

export const getInstalments = record => post(url.GET_INSTALLMENTS, record)